module.exports = __webpack_public_path__ + "static/media/shareMatter.52f8bc25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shareMatter.svg
// module id = 2342
// module chunks = 0